module.exports = __webpack_public_path__ + "img/panel_economic.ab29f791.svg";